"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeWindowChangeOrigin = void 0;
var TimeWindowChangeOrigin;
(function (TimeWindowChangeOrigin) {
    TimeWindowChangeOrigin["ORDER_CREATION_API"] = "order_creation_api";
    TimeWindowChangeOrigin["ORDER_CREATION_CSV"] = "order_creation_csv";
    TimeWindowChangeOrigin["ORDER_CREATION_WEB"] = "order_creation_web";
    TimeWindowChangeOrigin["CUSTOMER_EXPERIENCE_WEB_USER_RESCHEDULED"] = "customer_experience_web_user_rescheduled";
    TimeWindowChangeOrigin["CUSTOMER_EXPERIENCE_CUSTOMER_RESCHEDULED"] = "customer_experience_customer_rescheduled";
    TimeWindowChangeOrigin["QUOTES_FOR_FIRST_AVAILABILITY"] = "quotes_for_first_availability";
    TimeWindowChangeOrigin["PLANNED_DELIVERY_WINDOW_WITHOUT_QUOTES"] = "planned_delivery_window_without_quotes";
    TimeWindowChangeOrigin["NARROW_TIME_WINDOW"] = "narrow_time_window";
    TimeWindowChangeOrigin["ORDER_UPDATE_API"] = "order_update_api";
    TimeWindowChangeOrigin["ORDER_UPDATE_WEB"] = "order_update_web";
    TimeWindowChangeOrigin["AUTOMATION_PLATFORM"] = "automation_platform";
})(TimeWindowChangeOrigin || (exports.TimeWindowChangeOrigin = TimeWindowChangeOrigin = {}));
//# sourceMappingURL=time-window-change-origin.js.map